import React from "react";
import DocUp from "../images/docUpload.svg";
import EarlyIcon from "../images/earlyMenu.svg"
function Earlymenu(props) {
  return (
    <div className="menu-items otherServ cursor-pointer" onClick={() => props.showEarly()}>
      <div>
        <img src={EarlyIcon} alt="" />
      </div>
      <div className="mt-1">
        Early
        <br />
        Check-in
      </div>
    </div>
  );
}

export default Earlymenu;
